import React, {useState} from 'react';
import {Button, Modal} from 'antd';
import {IoExitOutline} from 'react-icons/io5';
import Cookies from 'js-cookie';
import {useNavigate} from 'react-router-dom';

const Logout = () => {
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
    const showModal = () => {
        setOpen(true);
    };
    const handleOk = () => {
        Cookies.remove('token')
        handleCancel()
        navigate("/login");
    };
    const handleCancel = () => {
        setOpen(false);
    };
    return (
        <>
            <div className='py-2 px-4 flex items-center gap-2   justify-start w-40' onClick={showModal}><IoExitOutline
                size={20}/>
                خروج
            </div>
            <Modal
                open={open}
                title="خروج از حساب کاربری"
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
            >
                <p className='mb-10 mt-5'>آیا از خروج خود اطمینان دارید؟</p>
                <div className='gap-2 flex justify-end items-center'>
                    <Button key="back" className='defBtn  redBtn ' onClick={handleCancel}>
                        انصراف
                    </Button>
                    <Button key="submit" className='defBtn blueBtn' onClick={handleOk}>
                        خروج
                    </Button>
                </div>
            </Modal>
        </>
    );
};
export default Logout;